import { useCallback, useEffect, useMemo, useRef } from "react";
import styles from "./MegaMenuPanel.module.css";
import { megaMenu } from "../../data/navigation";
import MegaMenuCard from "../MegaMenuCard/MegaMenuCard";

function MegaMenuPanel({ showMenu, setShowMenu, megaMenuState }) {
    const containerRef = useRef(null);
    const panelRef = useRef(null);
    const data = useMemo(() => megaMenu[megaMenuState], [megaMenuState]);

    function handleCoverClick() {
        setShowMenu(false);
    }

    const setPanelHeight = useCallback(() => {
        containerRef.current.style.setProperty(
            "--panelHeight",
            panelRef.current.offsetHeight + "px"
        );
    }, []);

    useEffect(() => {
        setPanelHeight();
    }, [megaMenuState, setPanelHeight]);

    return (
        <div
            ref={containerRef}
            id={styles.panel_container}
            className={[showMenu ? styles.open : "", "hide-scrollbar"].join(
                " "
            )}
        >
            <div id={styles.panel} ref={panelRef}>
                <div id={styles.content_container}>
                    <div id={styles.text}>
                        <strong id={styles.title}>{data.title}</strong>
                        <p id={styles.description}>{data.text}</p>
                    </div>
                    <div id={styles.grid}>
                        {data.children.map((obj) => (
                            <MegaMenuCard
                                {...obj}
                                key={obj.name}
                                setShowMenu={setShowMenu}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <div id={styles.click_cover} onClick={handleCoverClick}></div>
        </div>
    );
}

export default MegaMenuPanel;
